import Rule from "../../../../common/rule";
import ScoringMode from "../../../enums/scoring-mode";

export default class DoubleScoring extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { match }) {
        const { scoringMode, numberOfMatches } = eventConfiguration.doubles;
        if (
            scoringMode === ScoringMode.BestOfSeries.code &&
            !match.bothTeamsDisqualified() &&
            !match.hasNoPlayers()
        ) {
            const matchesToWin = numberOfMatches / 2;
            return (
                !ruleContext.doubleScoringApplied &&
                (ruleContext.doublesWonAway > matchesToWin ||
                    ruleContext.doublesWonHome > matchesToWin)
            );
        }

        return !match.bothTeamsDisqualified() && !match.hasNoPlayers();
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { match }) {
        if (match.winnerId === match.away.teamId) {
            gameContext.setVisitorScore(gameContext.getVisitorScore() + 1);
        } else {
            gameContext.setHomeScore(gameContext.getHomeScore() + 1);
        }
        // Only used when ScoringMode.BestOfSeries
        ruleContext.doubleScoringApplied = true;
    }
}
